import React, { useState } from 'react';
import { Stepper, StepProps, useSteps } from '@orbita-ui/core';
import Page from '../page';
import { FeesFormInputs } from '../Fees/modal-fees';
import { ChargesFormInputs } from '../Charges/modal-charges';
import { LimitsFormInputs } from '../Limits/limits';
import { UsageLimits } from '../UsageLimits/usage-limits';
import FirstStep, { FirstStepFormInputs } from './new/first-step';
import SecondStep from './new/second-step';
import ThirdStep from './new/third-step';
import FourthStep from './new/fourth-step';
import FiveStep from './new/five-step';

const NewCardAffinityGroup = () => {

  const [firstData, setFirstData] = useState<FirstStepFormInputs>(null);
  const [fees, setFees] = useState<FeesFormInputs[]>([]);
  const [charges, setCharges] = useState<ChargesFormInputs[]>([]);
  const [limit, setLimit] = useState<LimitsFormInputs>();
  const [usageLimit, setUsageLimit] = useState<UsageLimits>();

  const steps: StepProps[] = [
    {
      label: 'Datos principales',
      icon: 'UserIcon',
    },
    {
      label: 'Impuestos y los Cargos',
      icon: 'AddIcon',
    },
    {
      label: 'Limites',
      icon: 'AddIcon',
    },
    {
      label: 'Limitador de uso',
      icon: 'AddIcon',
    },
    {
      label: 'Finalizar',
      icon: 'CardsIcon',
    },
  ];

  const { activeStep, goToPrevious, goToNext } = useSteps({
    count: steps.length,
    index: 0,
  });

  return (
    <Page title="Nuevo Grupo de afinidad">
      <Stepper activeStep={activeStep} steps={steps} />
      {activeStep === 0 && <FirstStep goToNext={goToNext} firstStepData={firstData} setFirstStepData={setFirstData} />}
      {activeStep === 1 && <SecondStep fees={fees} charges={charges} setFees={setFees} setCharges={setCharges} goToNext={goToNext} goToPrevious={goToPrevious} /> }
      {activeStep === 2 && <ThirdStep limit={limit} setLimit={setLimit} goToNext={goToNext} goToPrevious={goToPrevious} /> }
      {activeStep === 3 && <FourthStep usageLimit={usageLimit} setUsageLimit={setUsageLimit} goToNext={goToNext} goToPrevious={goToPrevious} /> }
      {activeStep === 4 &&
        <FiveStep
          goToPrevious={goToPrevious}
          firstData = { firstData }
          fees = { fees }
          charges = { charges }
          limit = { limit }
          usageLimit = { usageLimit }
        />
      }
    </Page>
  )
}

export default NewCardAffinityGroup;